export { SpaDayDetailTemplate } from './SpaDayDetailTemplate';
export type { SpaDayDetailTemplateProps } from './SpaDayDetailTemplate.types';
